import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  createInformationFailed,
  createInformationSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';

export default function* createApplication(action) {
  try {
    // Полет фантазии в 3 часа ночи
    const pool = action.payload;
    const url = `https://as-taxi-external.fast.its-profit.ru/api/v1/ext-api/${pool.procedure.replace('_', '-')}s`;
    const formData = new FormData();
    Object.keys(pool.values).forEach(key => {
      const value = pool.values[key];
      if (key.includes('_file')) {
        formData.append(key, value[0]);
      } else if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    });

    const response = yield makeRequest(url, formData, action, 'POST', true, {}, true);
    const data = yield getBodyJson(response);
    if (response.status === OK) {
      yield put(createInformationSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(createInformationFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(createInformationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
